
import {createAsyncThunk} from '@reduxjs/toolkit'
import {getIndiJobStatus} from 'sr/utils/api/masterData/indiJobStatus/getIndiJobStatus'
export const fetchindiJobStatus = createAsyncThunk(
  'getIndiJobStatus',
  async () => {
    const response = await getIndiJobStatus()
    return response?.data
  }
)


